/**
 *
 * ModalCustom
 *
 */

import React from "react"
import { Modal, Button } from "antd"
import "./index.less"
import PropTypes from "prop-types"
import { loadTexts, sanitize } from "../../utils/i18n"

const ModalOnboarding = (props) => {
  const intl = loadTexts("onboarding")
  const percentStep = ((props.currentIndex + 1) * 100) / props.totalStep
  return (
    <Modal
      width={props.width || 520}
      className="modalCustomSup"
      style={{ top: 76 }}
      title={props.title}
      closable
      visible={props.open}
      {...(props.onBack ? { onBack: () => props.onBack() } : {})}
      onCancel={() => props.onClose()}
      footer={false}
      bodyStyle={props.bodyStyle}
      maskClosable={false}>
      <div className="modalOnboarding__progress">
        <span style={{ width: `${percentStep}%` }} />
      </div>
      <div
        className="modalOnboarding"
        style={{
          margin: props.margin || "0 auto",
          textAlign: props.textAlign || "center",
        }}>
        {props.image && (
          <img
            style={{ width: props.imageWidth || null }}
            className="modalOnboarding__image"
            src={props.image}
          />
        )}

        {props.children}

        {props.buttonStart && (
          <div className="modalOnboarding__footer">
            <Button
              className="modalOnboarding__footer--center"
              type="primary"
              onClick={props.onOk}>
              {props.buttonStart}
            </Button>
          </div>
        )}

        {props.buttonsStep && (
          <div className="modalOnboarding__footer">
            <Button onClick={props.onBack}>
              {intl.generalButtons.backButton}
            </Button>
            <Button
              className="modalOnboarding__footer--right"
              type="primary"
              onClick={props.onOk}>
              {props.nextButton || intl.generalButtons.nextButton}
            </Button>
          </div>
        )}
      </div>
    </Modal>
  )
}

ModalOnboarding.propTypes = {
  onBack: PropTypes.func,
  onOk: PropTypes.func,
  colorButton: PropTypes.string,
  textButton: PropTypes.string,
  modalOpen: PropTypes.bool,
  margin: PropTypes.string,
  textAlign: PropTypes.string,
  isLoadingButton: PropTypes.bool,
  buttonsStep: PropTypes.bool,
  buttonStart: PropTypes.string,
}

export default ModalOnboarding
